
// This is an auto generated file - do not edit!
// Swagger path: /api/Event/{id}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Event, EventUpdate
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class EventIdApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<Event> {
        return this._get<Event>(
            `/Event/${id}`,
            options
        );
    }

    put(id: string, event: EventUpdate, options = {}): Observable<Event> {
        return this._put<Event, EventUpdate>(
            `/Event/${id}`,
            new EventUpdate(event),
            options
        );
    }

    delete(id: string, options = {}): Observable<any> {
        return this._delete<any>(
            `/Event/${id}`,
            options
        );
    }
}
